/* eslint-disable no-new */
import { Toggle } from './toggle';

export default(() => {
    if (document.querySelector('.js-filters-toggle')) {
        new Toggle({
            source: document.querySelector('.js-filters-toggle'),
            target: document.querySelector('.search-filter__section-bottom'),
            sourceClass: null,
            targetClass: 'search-filter__section-bottom--active',
        });
    }
})();
